import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import UrlHelper from "js-url-helper";
import PantheonTransferLogList from "./partials/PantheonTransferLogList";
import qs from "qs";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import { request } from "../../../utils/Request";
import { isEmpty } from "lodash";
import moment from "moment-timezone";
import { getFromStorage, setToStorage } from "../../../utils/Helper";

const url = new UrlHelper();

const DEFAULT_DROPDOWNS = {
    legalEntities: [],
};

const PantheonTransferLog = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns, setDropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
        sort_field: null,
        sort_order: null,
    });

    const getDropdowns = async () => {
        try {
            const response = await request({
                url: '/suppliers/transfer/logs/pantheons/create',
                params: {
                    type: 'list',
                }
            });
            const { data } = response.data;
            setDropdowns({
                legalEntities: data.legal_entities
            });
        } catch (e) {
            setDropdowns(DEFAULT_DROPDOWNS);
        } finally {
            const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
            const fromStorage: any = getFromStorage('supplierPantheonTransferLogsModuleState');
            const defaultState = {
                page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
                per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
                search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
                initialized: true,
                sort_field: null,
                sort_order: null,
                filters: {
                    toDate: moment().endOf("year").endOf("day").format("YYYY-MM-DD[T]HH:mm:ss"),
                    fromDate: moment().startOf("year").startOf("day").format("YYYY-MM-DD[T]HH:mm:ss"),
                },
                ...(!isEmpty(fromStorage) ? JSON.parse(fromStorage) : {})
            }

            setModuleState(defaultState);
            setToStorage('supplierPantheonTransferLogsModuleState', JSON.stringify(defaultState));
        }
    };

    useEffect(() => {
        document.title = t("pantheon transfer logs");

        async function init() {
            await getDropdowns();
        }

        init();
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierPantheonTransferLogsModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <PantheonTransferLogList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// PantheonTransferLog.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(PantheonTransferLog);
